import markFirstDisruptionLeg from "./markFirstDisruptionLeg";
import removeFirstLegDisruptionsFromLaterLegs from "./removeFirstLegDisruptionsFromLaterLegs";
const getLegsWithoutRepeatingDisruptions = (legs) => {
  const { ndxFirstLegWithDisruptions, legsWithMarkedFirstDisruptionLeg } = markFirstDisruptionLeg(legs);
  const hasFirstLegFirstDisruption = ndxFirstLegWithDisruptions === 0;
  if (hasFirstLegFirstDisruption) {
    return removeFirstLegDisruptionsFromLaterLegs(legsWithMarkedFirstDisruptionLeg);
  }
  return legsWithMarkedFirstDisruptionLeg;
};
var getLegsWithoutRepeatingDisruptions_default = getLegsWithoutRepeatingDisruptions;
export {
  getLegsWithoutRepeatingDisruptions_default as default
};
